import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, ComputedRef, watch, Ref } from 'vue';
import store from '@/store';
import { Roles } from '@/typings/user';

import CSelect, { type CSelectItem, valueReducer } from '@/components/shared/CSelect';


export default /*#__PURE__*/_defineComponent({
  __name: 'LayersHeaderListPreview',
  setup(__props) {

const canvas = computed(() => {
    return store.state.storeLayers?.canvas;
});

const selectedPreview: Ref<string | undefined> = ref();

const listPreview: ComputedRef<CSelectItem<string>[]> = computed(() => {
    return canvas.value?._listPreview?.map((preview) => ({
        label: preview.name,
        value: `${preview.PreviewId}`,
    })) || [];
});

const flags = computed(() => {
    return store.state.storeLayers?.flags;
});

const isEnabled = computed(() => {
    if (flags.value?.isMyProductBases || flags.value?.isProductTemplate) {
        return false;
    }

    const user = store.state.user;
    if (!user) return false;

    const roles = user.AccessRoles?.Serialized.split(',');

    const isAdmin = roles?.includes(Roles.ADMIN);
    const impersonatedFromAdminUser = user.ImpersonatedFromAdminUser;
    const impersonatedFromChildUser = user.ImpersonatedFromChildUser;
    const isMultiPreview = roles?.includes(Roles.MULTI_PREVIEW);

    return Boolean((isAdmin || impersonatedFromAdminUser || isMultiPreview) && !impersonatedFromChildUser);
});

const onPreviewSelected = () => {
    if (!canvas.value) return;
    if (!selectedPreview.value) return;
    canvas.value.selectPreview(Number(selectedPreview.value));
};

watch(
    () => canvas.value?._selectedPreview,
    () => {
        selectedPreview.value = canvas.value?._selectedPreview?.PreviewId?.toString();
    }
);

return { __sfc: true,canvas, selectedPreview, listPreview, flags, isEnabled, onPreviewSelected, CSelect, valueReducer }
}

})